export default __webpack_public_path__ + "static/media/illustration-signup-mobile.2e9fc4be.svg";